<div class="row text-center unathorised">
    <i class="flaticon-lock"></i>
    <h1>401 - Unauthorized</h1>
    <h4>You are not authorized to access this page.</h4>
    <a mat-raised-button class="tagus mt-8 cursor-pointer" (click)="navigateToHome()">Back to Dashboard</a>
</div>